jQuery(document).ready(function($){

    //Add data to div
    $('[data-link]').on('click', function (e) {
        e.preventDefault();
        var did = $(this).data('link');
        $('div' + did).toggleClass('is-active');
    });

    //Active class to header on scroll
    $(window).on("scroll", function () {
        if ($(this).scrollTop() > 50) {
            $(".header").addClass("active");
        }
        else {
            $(".header").removeClass("active");
        }
    });

    $(window).scroll(function() {    
        var scroll = $(window).scrollTop();
    
         //>=, not <=
        if (scroll >= 50) {
            //clearHeader, not clearheader - caps H
            $(".header__elementor-fixed").addClass("active");
        } else {
            $(".header__elementor-fixed").removeClass("active"); 
        }
    });

    // 404 page slider
    $('.page-404__case-slider').flickity({
      // options
      cellAlign: 'center',
      contain: true,
      pageDots: false,
      autoPlay: 9000,
      wrapAround: true,
      fade: true
    });

    // 404 page height
    var $block_page = $('#page-404');
    var $footer_404 = $('#wrapper-footer');
    var $height_screen_404 = window.innerHeight;
    var $height_404 = $footer_404.height();
    var $new_height_404 = $height_screen_404 - $height_404;
    // console.log($height);
    // console.log($height_screen);
    // console.log($height_screen - $height);
    $($block_page).css("height", $new_height_404);

    //submenu
    $('.header__elementor ul li').mouseover(function() {
        $(this).find('.sub-menu').addClass('sub-menu--active');
    });

    $('.header__elementor ul li').mouseleave(function() {
        $(this).find('.sub-menu').removeClass('sub-menu--active');
    });

});

/* global jQuery, PhotoSwipe, PhotoSwipeUI_Default, console */

(function($) {

    var initPhotoSwipeFromDOM = function(gallerySelector) {

      // parse slide data (url, title, size ...) from DOM elements
      // (children of gallerySelector)
      var parseThumbnailElements = function(el) {
          var thumbElements = el.childNodes,
              numNodes = thumbElements.length,
              items = [],
              figureEl,
              linkEl,
              size,
              item;

          for(var i = 0; i < numNodes; i++) {

              figureEl = thumbElements[i]; // <figure> element

              // include only element nodes
              if(figureEl.nodeType !== 1) {
                  continue;
              }

              linkEl = figureEl.children[0]; // <a> element

              size = linkEl.getAttribute('data-size').split('x');

              // create slide object
              item = {
                  src: linkEl.getAttribute('href'),
                  w: parseInt(size[0], 10),
                  h: parseInt(size[1], 10)
              };



              if(figureEl.children.length > 1) {
                  // <figcaption> content
                  item.title = figureEl.children[1].innerHTML;
              }

              if(linkEl.children.length > 0) {
                  // <img> thumbnail element, retrieving thumbnail url
                  item.msrc = linkEl.children[0].getAttribute('src');
              }

              item.el = figureEl; // save link to element for getThumbBoundsFn
              items.push(item);
          }

          return items;
      };

      // find nearest parent element
      var closest = function closest(el, fn) {
          return el && ( fn(el) ? el : closest(el.parentNode, fn) );
      };

      // triggers when user clicks on thumbnail
      var onThumbnailsClick = function(e) {
          e = e || window.event;
          e.preventDefault ? e.preventDefault() : e.returnValue = false;

          var eTarget = e.target || e.srcElement;

          // find root element of slide
          var clickedListItem = closest(eTarget, function(el) {
              return (el.tagName && el.tagName.toUpperCase() === 'FIGURE');
          });

          if(!clickedListItem) {
              return;
          }

          // find index of clicked item by looping through all child nodes
          // alternatively, you may define index via data- attribute
          var clickedGallery = clickedListItem.parentNode,
              childNodes = clickedListItem.parentNode.childNodes,
              numChildNodes = childNodes.length,
              nodeIndex = 0,
              index;

          for (var i = 0; i < numChildNodes; i++) {
              if(childNodes[i].nodeType !== 1) {
                  continue;
              }

              if(childNodes[i] === clickedListItem) {
                  index = nodeIndex;
                  break;
              }
              nodeIndex++;
          }



          if(index >= 0) {
              // open PhotoSwipe if valid index found
              openPhotoSwipe( index, clickedGallery );
          }
          return false;
      };

      // parse picture index and gallery index from URL (#&pid=1&gid=2)
      var photoswipeParseHash = function() {
          var hash = window.location.hash.substring(1),
          params = {};

          if(hash.length < 5) {
              return params;
          }

          var vars = hash.split('&');
          for (var i = 0; i < vars.length; i++) {
              if(!vars[i]) {
                  continue;
              }
              var pair = vars[i].split('=');
              if(pair.length < 2) {
                  continue;
              }
              params[pair[0]] = pair[1];
          }

          if(params.gid) {
              params.gid = parseInt(params.gid, 10);
          }

          return params;
      };

      var openPhotoSwipe = function(index, galleryElement, disableAnimation, fromURL) {
          var pswpElement = document.querySelectorAll('.pswp')[0],
              gallery,
              options,
              items;

          items = parseThumbnailElements(galleryElement);

          // define options (if needed)
          options = {

              // define gallery index (for URL)
              galleryUID: galleryElement.getAttribute('data-pswp-uid'),

              getThumbBoundsFn: function(index) {
                  // See Options -> getThumbBoundsFn section of documentation for more info
                  var thumbnail = items[index].el.getElementsByTagName('img')[0], // find thumbnail
                      pageYScroll = window.pageYOffset || document.documentElement.scrollTop,
                      rect = thumbnail.getBoundingClientRect();

                  return {x:rect.left, y:rect.top + pageYScroll, w:rect.width};
              }

          };

          // PhotoSwipe opened from URL
          if(fromURL) {
              if(options.galleryPIDs) {
                  // parse real index when custom PIDs are used
                  // http://photoswipe.com/documentation/faq.html#custom-pid-in-url
                  for(var j = 0; j < items.length; j++) {
                      if(items[j].pid == index) {
                          options.index = j;
                          break;
                      }
                  }
              } else {
                  // in URL indexes start from 1
                  options.index = parseInt(index, 10) - 1;
              }
          } else {
              options.index = parseInt(index, 10);
          }

          // exit if index not found
          if( isNaN(options.index) ) {
              return;
          }

          if(disableAnimation) {
              options.showAnimationDuration = 0;
          }

          // Pass data to PhotoSwipe and initialize it
          gallery = new PhotoSwipe( pswpElement, PhotoSwipeUI_Default, items, options);
          gallery.init();
      };

      // loop through all gallery elements and bind events
      var galleryElements = document.querySelectorAll( gallerySelector );

      for(var i = 0, l = galleryElements.length; i < l; i++) {
          galleryElements[i].setAttribute('data-pswp-uid', i+1);
          galleryElements[i].onclick = onThumbnailsClick;
      }

      // Parse URL and open gallery if it contains #&pid=3&gid=1
      var hashData = photoswipeParseHash();
      if(hashData.pid && hashData.gid) {
          openPhotoSwipe( hashData.pid ,  galleryElements[ hashData.gid - 1 ], true, true );
      }
  };

  // execute above function
  initPhotoSwipeFromDOM('.my-gallery');


}(jQuery));

// function initMap(){
//     // map options
//     var options = {
//       zoom:7,
//       center:{lat:53.3938131, lng:-7.858913}
//       }
      
//     var mapOptions = {
//         zoom:7,

//         // The latitude and longitude to center the map (always required)
//         center:{lat:53.3938131, lng:-7.858913}, 

//         // Disables the default Google Maps UI components
//         disableDefaultUI: false,
//         scrollwheel: true,
//         draggable: true,
//         styles: [
//             {
//                 "featureType": "landscape",
//                 "stylers": [
//                     {
//                         "saturation": -100
//                     },
//                     {
//                         "lightness": 65
//                     },
//                     {
//                         "visibility": "on"
//                     }
//                 ]
//             },
//             {
//                 "featureType": "poi",
//                 "stylers": [
//                     {
//                         "saturation": -100
//                     },
//                     {
//                         "lightness": 51
//                     },
//                     {
//                         "visibility": "simplified"
//                     }
//                 ]
//             },
//             {
//                 "featureType": "road.highway",
//                 "stylers": [
//                     {
//                         "saturation": -100
//                     },
//                     {
//                         "visibility": "simplified"
//                     }
//                 ]
//             },
//             {
//                 "featureType": "road.arterial",
//                 "stylers": [
//                     {
//                         "saturation": -100
//                     },
//                     {
//                         "lightness": 30
//                     },
//                     {
//                         "visibility": "on"
//                     }
//                 ]
//             },
//             {
//                 "featureType": "road.local",
//                 "stylers": [
//                     {
//                         "saturation": -100
//                     },
//                     {
//                         "lightness": 40
//                     },
//                     {
//                         "visibility": "on"
//                     }
//                 ]
//             },
//             {
//                 "featureType": "transit",
//                 "stylers": [
//                     {
//                         "saturation": -100
//                     },
//                     {
//                         "visibility": "simplified"
//                     }
//                 ]
//             },
//             {
//                 "featureType": "administrative.province",
//                 "stylers": [
//                     {
//                         "visibility": "off"
//                     }
//                 ]
//             },
//             {
//                 "featureType": "water",
//                 "elementType": "labels",
//                 "stylers": [
//                     {
//                         "visibility": "on"
//                     },
//                     {
//                         "lightness": -25
//                     },
//                     {
//                         "saturation": -100
//                     }
//                 ]
//             },
//             {
//                 "featureType": "water",
//                 "elementType": "geometry",
//                 "stylers": [
//                     {
//                         "hue": "#ffff00"
//                     },
//                     {
//                         "lightness": -25
//                     },
//                     {
//                         "saturation": -97
//                     }
//                 ]
//             }

//         ]
//     };

// var map = new google.maps.Map(document.getElementById('map'),mapOptions);
//     // Add a marker clusterer to manage the markers.

//     //Add marker
//     var markers = [

//       //Dublin
//       {
//         coords:{lat:53.338741, lng:-6.261563},
//         iconImage:'assets/img/places/stparkdublin.png',
//         content:'<h1>St Stephen’s Green</h1>'+ '<br>' + '<h2>Learn More</h2>' + '<a>http://ststephensgreenpark.ie/</a>',
//         cat: 'car'
//       },
//       {
//         coords:{lat:53.3755012,lng:-6.2735677},
//         iconImage:'assets/img/places/botanic garden.png',
//         content:'<h1>Botanic Garden</h1>' + '<br>' + '<h2>Learn More</h2>' + '<a>http://botanicgardens.ie/</a>',
//         cat: 'second'
//       },
//       {
//         coords:{lat:53.355998576, lng:-6.32166538},
//         iconImage:'assets/img/places/stparkdublin.png',////////////////////add picture
//         content:'<h1>Phoenix Park</h1>' + '<br>' + '<h2>Learn More</h2>' + '<a>http://phoenixpark.ie/</a>',
//         cat: 'third'
//       },
//       {
//         coords:{lat:53.460259, lng:-6.219985},
//         iconImage:'assets/img/places/swordscastle.png',
//         content:'<h1>Swords Castle</h1>'+ '<br>' + '<h2>Learn More</h2>' + '<a>https://swordscastle.events/</a>',
//         cat: 'second'
//       },
//       {
//         coords:{lat:53.37923, lng:-6.07201},
//         iconImage:'assets/img/places/Howth.png',
//         content:'<h1>Howth</h1>'+ '<br>' + '<h2>Learn More</h2>' + '<a>http://www.visithowth.ie/</a>',
//         cat: 'car'
//       },
//       {
//         coords:{lat:55.1364, lng:-7.456},
//         iconImage:'assets/img/places/buncrana1.png',
//         content:'<h1>Buncrana</h1>'+ '<br>' + '<h2>Learn More</h2>' + '<a>https://en.wikipedia.org/wiki/Buncrana</a>',
//         cat: 'third'
//       },

//       {
//         coords:{lat:53.152999388, lng:-6.1499994},
//         iconImage:'assets/img/places/sugarloaf_icon.png',
//         content:'<h1>Great sugar loaf</h1>'+ '<br>' + '<h2>Learn More</h2>' + '<a>http://visitwicklow.ie/item/the-sugarloaf-trail/</a>',
//         cat: 'car'
//       },
//       {
//         coords:{lat:52.0058, lng:-9.5562},
//         iconImage:'assets/img/places/killarney.png',
//         content:'<h1>Killarney National Park </h1>'+ '<br>' + '<h2>Learn More</h2>' + '<a>https://www.killarneynationalpark.ie/</a>',
//         cat: 'car'
//       },
//       {
//         coords:{lat:51.942662896, lng:-9.917162998},
//         iconImage:'assets/img/places/clifs.png',
//         content:'<h1>Ring of Kerry</h1>'+ '<br>' + '<h2>Learn More</h2>' + '<a>https://ringofkerrytourism.com/</a>',
//         cat: 'car'
//       },
//       {
//         coords:{lat:52.679, lng:-7.814},
//         iconImage:'assets/img/places/clifs.png',//add picture!!!!!!!!!!!!!!!
//         content:'<h1>Thurles</h1>'+ '<br>' + '<h2>Learn More</h2>' + '<a>https://www.tipperary.com/thurles</a>',
//         cat: 'car'
//       },
//       {
//         coords:{lat:52.348, lng:-6.517},
//         iconImage:'assets/img/places/wexford museum.png',
//         content:'<h1>Irish National Heritage Park</h1>'+ '<br>' + '<h2>Learn More</h2>' + '<a>http://www.irishheritage.ie/</a>',
//         cat: 'car'
//       },
//       {
//         coords:{lat:53.018, lng:-6.398},
//         iconImage:'assets/img/places/wicklow.png',
//         content:'<h1> Wicklow Mountains National Park</h1>'+ '<br>' + '<h2>Learn More</h2>' + '<a>https://www.wicklowmountainsnationalpark.ie/</a>',
//         cat: 'car'
//       },
//       {
//         coords:{lat:53.011299, lng:   -6.326156},
//         iconImage:'assets/img/places/glendalough.png',
//         content:'<h1> Glendalough </h1>'+ '<br>' + '<h2>Learn More</h2>' + '<a>http://www.glendalough.ie/</a>',
//         cat: 'car'
//       },
//       {
//         coords:{lat:53.1876492494, lng:-6.083832998},
//         iconImage:'assets/img/places/Bray.png',
//         content:'<h1> Bray</h1>'+ '<br>' + '<h2>Learn More</h2>' + '<a>http://www.bray.ie/</a>',
//         cat: 'car'
//       },
//       {
//         coords:{lat:53.144, lng: -6.072},
//         iconImage:'assets/img/places/greystones.png',
//         content:'<h1>Greystones</h1>'+ '<br>' + '<h2>Learn More</h2>' + '<a>http://visitwicklow.ie/item/greystones/</a>',
//         cat: 'car'
//       },
//       {
//         coords:{lat:52.518664592, lng:-7.887329784},
//         iconImage:'assets/img/places/Cashel.png',
//         content:'<h1>Rock of Cashel</h1>'+ '<br>' + '<h2>Learn More</h2>' + '<a>https://www.cashel.ie/</a>',
//         cat: 'car'
//       },
//       {
//         coords:{lat:52.6477, lng: -7.2561},
//         iconImage:'assets/img/places/kilkenny.png',
//         content:'<h1>Killenny</h1>'+ '<br>' + '<h2>Learn More</h2>' + '<a>https://visitkilkenny.ie/</a>',
//         cat: 'car'
//       },
//       //cork
//       {
//         coords:{lat:51.902694, lng:-8.4767},
//         iconImage:'assets/img/places/butterCork.png',
//         content:'<h1>Museum of Butter</h1>'+ '<br>' + '<h2>Learn More</h2>' + '<a>http://thebuttermuseum.com/</a>',
//         cat: 'car'
//       },
//       {
//         coords:{lat:51.89953, lng:-8.499022},
//         iconImage:'assets/img/places/prisoncork.png',
//         content:'<h1>Cork City Gaol</h1>'+'<br>' + '<h2>Learn More</h2>' + '<a>https://corkcitygaol.com/</a>',
//         cat: 'car'
//       },

//       {
//         coords:{lat:53.4513204, lng:-6.140871},
//         iconImage:'assets/img/places/malahideB.png',
//         content:'<h1>Malahide</h1>'+'<br>' + '<h2>Learn More</h2>' + '<a>https://www.malahide.ie/</a>',
//         cat: 'second'
//       },

//       {
//         coords:{lat:53.2839577, lng:-9.0837658},
//         iconImage:'assets/img/places/galway.png',
//         content:'<h1>Galway</h1>'+'<br>' + '<h2>Learn More</h2>' + '<a>https://www.galwaytourism.ie/</a>',
//         cat: 'car'
//       },
//       {
//         coords:{lat:53.470580, lng:-6.122405},
//         iconImage:'assets/img/places/galway.png',
//         content:'<h1>Donabate Beach</h1>'+'<br>' + '<h2>Learn More</h2>' + '<a>https://en.wikipedia.org/wiki/Donabate</a>',
//         cat: 'second'
//       },
//       {
//         coords:{lat:52.9713299, lng:-9.4300415},
//         iconImage:'assets/img/places/clifsofmoher.png',
//         content:'<h1>Donabate Beach</h1>'+'<br>' + '<h2>Learn More</h2>' + '<a>https://www.cliffsofmoher.ie/</a>',
//         cat: 'second'
//       },
//       {
//         coords:{lat:51.8960528, lng:-8.4980693},
//         iconImage:'assets/img/places/Cork.png',
//         content:'<h1>Cork</h1>'+'<br>' + '<h2>Learn More</h2>' + '<a>https://purecork.ie/</a>',
//         cat: 'car'
//       },
//       {
//         coords:{lat:53.3667776, lng:-6.5064198},
//         iconImage:'assets/img/places/Leixlip.png',
//         content:'<h1>Leixlip</h1>'+'<br>' + '<h2>Learn More</h2>' + '<a>https://pl.wikipedia.org/wiki/Leixlip</a>',
//         cat: 'car'
//       },
//       {
//         coords:{lat:53.1654628, lng:-6.125499},
//         iconImage:'assets/img/places/littlesugarloaf.png',
//         content:'<h1>Little Sugar Loaf</h1>'+'<br>' + '<h2>Learn More</h2>' + '<a>https://www.greystonesguide.ie/little-sugar-loafs-big-day/</a>',
//         cat: 'third'
//       },
//       {
//         coords:{lat:53.5474019, lng:-6.0933048},
//         iconImage:'assets/img/places/rockabill view.png',
//         content:'<h1>Rockabill View</h1>'+'<br>' + '<h2>Learn More</h2>' + '<a>http://www.skerriesseatours.ie/trips.html</a>',
//         cat: 'second'
//       },
//       {
//         coords:{lat:52.3337499, lng:-6.4906996},
//         iconImage:'assets/img/places/wexford.png',
//         content:'<h1>Wexford</h1>'+'<br>' + '<h2>Learn More</h2>' + '<a>https://www.visitwexford.ie/</a>',
//         cat: 'third'
//       },
//     ];

    


//     // Loop through markers
//     var gmarkers = [];
//     for(var i = 0; i < markers.length; i++){
//       gmarkers.push(addMarker(markers[i]));

//     }

//     //Add MArker function
//     function addMarker(props){
//       var marker = new google.maps.Marker({
//         position:props.coords,
//         category:props.cat,
//         map:map

//       });
      
//       /* if(props.iconImage){
//         marker.setIcon(props.iconImage);
//       } */

//       //Check content
//       if(props.content){
//         var infoWindow = new google.maps.InfoWindow({
//           content:props.content
//         });
//         marker.addListener('click',function(){
//           infoWindow.open(map,marker);
//         });
//       }
//       return marker;
//     }

//      /**
//      * Function to filter markers by category
//      */
//     // Sets the map on all markers in the array.
//         function setAllMap(map) {
//             for (var i = 0; i < gmarkers.length; i++) {
//             gmarkers[i].setMap(map);
//             }
//         }
    

//     filterMarkers = function (category) {
        

        

//         var gmarkers_custom = [];
//         var bounds = new google.maps.LatLngBounds();
//         for (i = 0; i < gmarkers.length; i++) {
//             marker = gmarkers[i];
//             // If is same cat or cat not picked
//             if (marker.category == category || category.length === 0) {
//                 marker.setVisible(true);
//                 bounds.extend(marker.getPosition());

//                 gmarkers_custom.push(marker);
                
//             }
//             // Categories don't match 
//             else {
//                 marker.setVisible(false);
//             }
//             map.fitBounds(bounds);
//         }

//         // Enable marker clustering for this map and these markers
//         const imagePath = "https://developers.google.com/maps/documentation/javascript/examples/markerclusterer/m";
//         const markerClusterer = new MarkerClusterer(map, gmarkers_custom, {imagePath: imagePath});
        
//     }
//   }


// google.maps.event.addDomListener(window, 'load', initMap)